import { render, staticRenderFns } from "./InjectionLinkComponent.vue?vue&type=template&id=0b78c6ce&"
import script from "./InjectionLinkComponent.vue?vue&type=script&lang=js&"
export * from "./InjectionLinkComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports